import PaymentsIcon from "@mui/icons-material/Payments";
import { BUDGETS, ScholarshipServicePath } from "utils/constants";
import ListScholarshipBudget from "./List";
import CreateScholarshipBudget from "./Create";
import EditScholarshipBudget from "./Edit";
import permissions from "app/permissions";

export const resources = {
  isMenu: true,
  icon: <PaymentsIcon />,
  name: ScholarshipServicePath + BUDGETS,
  title: "Бюджет стипендии",
  list: <ListScholarshipBudget />,
  create: <CreateScholarshipBudget />,
  edit: <EditScholarshipBudget />,
  permission: permissions.canPreviewScholarshiBudgets,
};
